/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SaveStoreSpendingRequest { 
    id?: number;
    spendCategoryCode: string;
    storeId: number;
    total: number;
    date: string;
    incomingNumber?: string;
    cashFlowCategoryCode?: string;
    payBefore: string;
}

